/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid, PageGridContainer, Typography2, breakpoints } from '@coursera/cds-core';

import type { DomainPillItemElement } from 'bundles/page-config-common/components/shared/DomainPillItem';
import { useHeaderLevel } from 'bundles/page-config-common/contexts/HeaderLevelContext';

const styles = {
  bottomPadding: css`
    ${breakpoints.down('md')} {
      margin-bottom: 10px;
    }
  `,
  headingOffset: css`
    margin-bottom: calc(var(--cds-spacing-200) * -1);

    ${breakpoints.down('sm')} {
      margin-bottom: inherit;
    }
  `,
};

type Props = {
  domainPillItems?: Array<DomainPillItemElement>;
  title: string;
  titleSize?: 'titleSmall' | 'subtitleLarge' | 'subtitleMedium';
};

const DomainPillsModule = ({ domainPillItems, title, titleSize = 'titleSmall' }: Props) => {
  const { currentLevel } = useHeaderLevel();

  if (!domainPillItems?.length) {
    return null;
  }

  return (
    <PageGridContainer css={styles.bottomPadding}>
      <Grid item xs={12}>
        <Typography2 variant={titleSize} component={currentLevel} css={styles.headingOffset}>
          {title}
        </Typography2>
      </Grid>
      <Grid item xs={12}>
        <Grid item container spacing={12}>
          {domainPillItems.map((domainPill) => (
            <Grid item xs={12} md={6} lg={4} key={domainPill.key}>
              {domainPill}
            </Grid>
          ))}
        </Grid>
      </Grid>
    </PageGridContainer>
  );
};

export default DomainPillsModule;
